export default __webpack_public_path__ + "static/media/qr_m01.729beb39.jpg";